import { Component, OnInit } from '@angular/core';
import { getSkuMetadataState, SkuMetadataState } from '@emi/shared/state/sku-metadata';
import { select, Store } from '@ngrx/store';
import * as Constants from '@emi/shared/constants';

@Component({
  selector: 'via-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public version: string;
  public dateCurrentYear = new Date().getFullYear().toString();
  public contactRoute = Constants.Routes.CONTACT_US;
  public privacyPolicyLink = Constants.ExternalLinks.ECOM_PRIVACY_POLICY;

  constructor(private skuMetadataStore: Store<SkuMetadataState>) { }

  public ngOnInit(): void {
    this.skuMetadataStore.pipe(select(getSkuMetadataState)).subscribe(x => this.version = x.version);
  }
}
